<template>
  <section class="section center">
    <h1>Simple pricing</h1>
    <p class="lead">No contracts. Cancel anytime.</p>
  </section>

  <section class="section grid">
    <div class="card">
      <h2>Starter</h2>
      <div class="price">$19/mo</div>
      <p>Includes up to 5 employees.</p>
      <RouterLink class="button" to="/registercompany?plan=starter">Start Starter</RouterLink>
    </div>

    <div class="card">
      <h2>Growth</h2>
      <div class="price">$4/employee/mo</div>
      <p>Best for growing teams.</p>
      <RouterLink class="button" to="/registercompany?plan=growth">Start Growth</RouterLink>
    </div>

    <div class="card">
      <h2>Enterprise</h2>
      <div class="price">Custom</div>
      <p>Large companies and integrations.</p>
      <a class="button" href="mailto:sales@miss-kal.uk">Contact sales</a>
    </div>
  </section>
</template>
